import { Play, Pause, Volume2, VolumeX, Wind, Orbit, ChevronUp, ChevronDown } from "lucide-react";

const btnClass = (active) =>
    `flex h-11 w-11 items-center justify-center rounded-full border backdrop-blur-md transition-all duration-300 ${
        active
            ? "border-terracotta bg-terracotta text-cream shadow-[0_14px_30px_-12px_rgba(200,90,50,0.7)]"
            : "border-line bg-white/70 text-inksoft hover:border-terracotta hover:text-terracotta"
    }`;

export const HUD = ({
    playing,
    voiceOn,
    ambientOn,
    exploring,
    onPlay,
    onVoice,
    onAmbient,
    onExplore,
    onFly,
}) => (
    <>
        <div
            data-testid="journey-hud"
            className="fixed bottom-8 right-5 z-30 flex flex-col gap-2.5 sm:right-8"
        >
            <button
                data-testid="play-journey-button"
                onClick={onPlay}
                title={playing ? "Pause the journey" : "Play the journey"}
                aria-label={playing ? "Pause the journey" : "Play the journey"}
                className={btnClass(playing)}
            >
                {playing ? <Pause size={17} /> : <Play size={17} className="ml-0.5" />}
            </button>
            <button
                data-testid="explore-toggle-button"
                onClick={onExplore}
                title={exploring ? "Exit explore mode" : "Explore the world in 3D"}
                aria-label="Toggle explore mode"
                className={btnClass(exploring)}
            >
                <Orbit size={17} />
            </button>
            <button
                data-testid="voice-narration-toggle"
                onClick={onVoice}
                title={voiceOn ? "Mute narration" : "Voice narration"}
                aria-label="Toggle narration"
                className={btnClass(voiceOn)}
            >
                {voiceOn ? <Volume2 size={17} /> : <VolumeX size={17} />}
            </button>
            <button
                data-testid="ambient-sound-toggle"
                onClick={onAmbient}
                title="Village ambience"
                aria-label="Toggle village ambience"
                className={btnClass(ambientOn)}
            >
                <Wind size={17} />
            </button>
        </div>
        {exploring && (
            <div className="fixed bottom-8 left-5 z-30 flex flex-col gap-2.5 sm:left-8">
                <button
                    data-testid="fly-forward-hold"
                    title="Hold to fly forward"
                    aria-label="Fly forward"
                    onTouchStart={() => onFly(1)}
                    onTouchEnd={() => onFly(0)}
                    onMouseDown={() => onFly(1)}
                    onMouseUp={() => onFly(0)}
                    onMouseLeave={() => onFly(0)}
                    className={btnClass(false)}
                >
                    <ChevronUp size={17} />
                </button>
                <button
                    data-testid="fly-back-hold"
                    title="Hold to fly backward"
                    aria-label="Fly backward"
                    onTouchStart={() => onFly(-1)}
                    onTouchEnd={() => onFly(0)}
                    onMouseDown={() => onFly(-1)}
                    onMouseUp={() => onFly(0)}
                    onMouseLeave={() => onFly(0)}
                    className={btnClass(false)}
                >
                    <ChevronDown size={17} />
                </button>
            </div>
        )}
    </>
);

export default HUD;
